// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PIndentOutlinedSvg from "@fishx/icons-svg/es/asn/PIndentOutlined";
import FishxIcon from '../components/FishxIcon';

var PIndentOutlined = function PIndentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PIndentOutlinedSvg
  }));
};

PIndentOutlined.displayName = 'PIndentOutlined';
export default React.forwardRef(PIndentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PIndentOutlined.js
// module id = 3462
// module chunks = 0